import { createRoot } from 'react-dom/client';
import Landing from "./src/Landing";

const app = document.getElementById("app");
const root = createRoot(app);
root.render(<Landing />);